/*
 * @Description: 退货单
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  退货单: '退货单',
  退货总金额: '退货总金额',
  请先选择客户: '请先选择客户！',
  只能选择一个负责人: '只能选择一个负责人!',
  只能选择一种币种: '只能选择一种币种!',
  至少添加一条明细: '至少添加一条明细!',
  请完善明细行: '请完善明细行!',
  添加明细: '添加明细',
  请输入销售订单编号: '请输入销售订单编号',
  销售订单产品: '销售订单产品',
  请输入订单产品编号: '请输入订单产品编号',
  暂无此退货单查看权限: '暂无此退货单查看权限'
};
